const priorities = {
  critical: { label: 'Critical', value: 100.5, id: 100.5 },
  high: { label: 'High', value: 200.5, id: 200.5 },
  medium: { label: 'Medium', value: 300.5, id: 300.5 },
  low: { label: 'Low', value: 400.5, id: 400.5 },
};

export const IN_APP_PRIORITIES = [
  priorities.critical,
  priorities.high,
  priorities.medium,
  priorities.low,
];

export const DEFAULT_IN_APP_PRIORITY = priorities.medium.value;
